import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GenerateIncrementlettersPreviewPopupComponent } from 'src/app/shared/popups/generate-incrementletters-preview-popup/generate-incrementletters-preview-popup.component';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';


@Component({
  selector: 'app-generate-increment-letters',
  templateUrl: './generate-increment-letters.component.html',
  styleUrls: ['./generate-increment-letters.component.scss'],
})
export class GenerateIncrementLettersComponent implements OnInit {
  buttonColorName: any;
  loggedInUserCompanyID: any;
  incrementId: any;
  loggedInUserRole: any;
  getIncrementFyYearList: any[] = [];
  fromYear: any;
  toYear: any;
  dropdownSettings: IDropdownSettings = {};
  selectedDepartment: any;
  selectedBand: any;
  selectedManager: any;
  selectedEmployee: any;
  selectedRating: any;
  managerId: any;
  employeeId: any;
  searchGenerateIncrementTableData: any;
  loggedInCompanyFiscalyear: any;
  selectedYear: any;
  getIncrementInputYear: any[] = [];
  companyYears: any[] = [];
  getDepartmentsList: any[] = [];
  getBandList: any[] = [];
  getManagerList: any[] = [];
  getEmployeeList: any[] = [];
  getSelectedRating: any[] = [];
  getRatingData: any[] = [];
  isShowDownloadBtn: boolean = false;
  selectAllChecked: boolean = false;
  incrementLetterData: any[] = [];
  isShowMD:any;
  loggedInUserRoles:any;
  loggedInUserIsMD:any;

  constructor(private route: Router, private httpService: HttpService, private config: Config,
    private encryptionService: EncryptionService, public dialog: MatDialog,private mobileresponsiveService:MobileResponsiveService,
    private http: HttpClient) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.isShowMD = this.loggedInUserRoles.some((role: any) => role.name === 'MD');   
    if (this.isShowMD || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD' || this.loggedInUserRole == 'HOD') {
      this.loggedInUserIsMD = true;
    } else if (this.loggedInUserRole == 'Manager') {
      this.loggedInUserIsMD = false;
    }
    else {
      this.loggedInUserIsMD = false;
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
  }

  ionViewWillEnter() {
    this.getIncrementYearList();
  }

  onClickGoToIncrementPage() {
    this.route.navigate(['/home/hrportal/increment'])
  }

  getIncrementYearList() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "toYear": null
    }
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result: any) => {
      this.getIncrementFyYearList = result.data.map((ele: any) => ({
        fromYear: ele.fromYear,
        toYear: ele.toYear,
        year: `${ele.fromYear}-${ele.toYear}`,
      }));
   
      const currentYear = new Date().getFullYear();
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth(); 
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
        if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
          if(currentMonth<3){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          } 
        }
        if(this.loggedInCompanyFiscalyear === 'July_Jun'){
          if(currentMonth<6){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if(this.loggedInCompanyFiscalyear === 'Oct_Sep'){
          if(currentMonth<9){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }
      this.fromYear = this.getIncrementFyYearList[selectedYearIndex].fromYear;
      this.toYear = this.getIncrementFyYearList[selectedYearIndex].toYear;
      this.getDepartmentByYear();

      this.isGetIncrementLetter()
    })
  }

  getDepartmentByYear() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      toYear: this.toYear,
      isHod: this.loggedInUserRole == 'HOD' && !this.isShowMD,
      isEligible: true,
    };

    this.httpService.callPostService(this.config.getDepartmentsByYearRange, request).subscribe((result: any) => {
      this.getDepartmentsList = result.data.map((ele: any) => ({
        id: ele,
        name: ele,
      })).sort((a: any, b: any) => a.name.localeCompare(b.name));

      // // Preselect all departments
      // this.selectedDepartment = [...this.getDepartmentsList];
    });
  }


  onSelectDepartment() {
    if (this.selectedDepartment.length > 0) {
      this.getBandList = [];
      this.selectedBand = ""
      this.selectedManager = "";
      this.selectedEmployee = "";
      this.selectedRating = '';
      this.getBandListByDepartment();
      this.isGetIncrementLetter();
    } else {
      this.getBandList = [];
      this.selectedBand = ""
      this.selectedManager = "";
      this.selectedEmployee = "";
      this.selectedRating = '';
    }
  }

  onDeSelectDepartment() {
    this.getBandList = [];
    this.getEmployeeList = [];
    this.getRatingData = [];
    this.getManagerList = [];
    this.selectedBand = ""
    this.selectedManager = "";
    this.selectedEmployee = "";
    this.selectedRating = '';
    this.isGetIncrementLetter();

  }



  selectAllDepartment(items: any): void {
    this.selectedDepartment = items;
    this.onSelectDepartment();
    this.selectedBand = ""
    this.selectedManager = "";
    this.selectedEmployee = "";
    this.selectedRating = '';
  }

  onDeSelectAllDepartment() {
    this.selectedDepartment = [];
    this.getBandList = [];
    this.getEmployeeList = [];
    this.getRatingData = [];
    this.getManagerList = [];
    this.selectedBand = ""
    this.selectedManager = "";
    this.selectedEmployee = "";
    this.selectedRating = '';
    this.isGetIncrementLetter();

  }

  //  Band

  getBandListByDepartment() {
    const request: any = {
      fromYear:this.fromYear,
      toYear:this.toYear,
      companyId: this.loggedInUserCompanyID,
      department: this.selectedDepartment.map((dept: any) => dept.name),
      isEligible: true,
    };
    this.httpService.callPostService(this.config.getBandListByDepartment, request)
      .subscribe((result: any) => {
        if (result.data) {
          this.getBandList = result.data.map((ele: any) => ({
            id: ele,
            name: ele
          })).sort((a: any, b: any) => a.name.localeCompare(b.name));;;
        }
      });
  }

  onSelectdBand() {
    if (this.selectedBand.length > 0) {
      this.getManagerList = [];
      this.selectedManager = "";
      this.selectedEmployee = "";
      this.selectedRating = '';
      this.getManagerListByBand();
      this.isGetIncrementLetter();

    } else {
      this.getManagerList = [];
      this.selectedManager = "";
      this.selectedEmployee = "";
      this.selectedRating = '';
    }
  }

  onDeSelectdBand() {
    this.getManagerList = [];
    this.getEmployeeList = [];
    this.getRatingData = [];
    this.selectedManager = "";
    this.selectedEmployee = "";
    this.selectedRating = '';
    this.isGetIncrementLetter();

  }

  selectAllBand(items: any): void {
    this.selectedBand = items;
    this.selectedManager = "";
    this.selectedEmployee = "";
    this.selectedRating = '';
    this.onSelectdBand()
  }

  onDeSelectAllBand() {
    this.selectedBand = [];
    this.getManagerList = [];
    this.selectedManager = "";
    this.selectedEmployee = "";
    this.selectedRating = '';
    this.getEmployeeList = [];
    this.getRatingData = [];
    this.isGetIncrementLetter();
  }

  // Manager

  getManagerListByBand() {
    const request: any = {
      bands: this.selectedBand.map((band: any) => band.name),
      companyId: this.loggedInUserCompanyID,
      department: this.selectedDepartment.map((dept: any) => dept.name),
      fromYear: this.fromYear,
      toYear: this.toYear,
      isEligible: true,
    };
    this.httpService.callPostService(this.config.getManagerListByBand, request).subscribe((result: any) => {
      if (result.data) {
        this.getManagerList = result.data.map((ele: any) => ({
          name: ele.name,
          id: ele.id,
          managerId: ele.employeeId
        })).sort((a: any, b: any) => a.name.localeCompare(b.name));;;
      }
    });
  }

  onSelectdManager() {
    if (this.selectedManager.length > 0) {
      this.getEmployeeList = [];
      this.getRatingData = [];
      this.selectedEmployee = "";
      this.selectedRating = '';
      this.getEmployeeListByManager()
      this.isGetIncrementLetter();

    } else {
      this.getEmployeeList = [];
      this.getRatingData = [];
      this.selectedEmployee = "";
      this.selectedRating = '';
    }
  }

  onDeSelectdManager() {
    this.getEmployeeList = [];
    this.getRatingData = [];
    this.selectedEmployee = "";
    this.selectedRating = '';
    this.isGetIncrementLetter();

  }

  selectAllManager(items: any): void {
    this.selectedManager = items;
    this.selectedEmployee = "";
    this.selectedRating = '';
    this.onSelectdManager()
  }

  onDeSelectAllManager() {
    this.selectedManager = [];
    this.getEmployeeList = [];
    this.getRatingData = [];
    this.selectedEmployee = "";
    this.selectedRating = '';
    this.isGetIncrementLetter();

  }

  // Employee 

  getEmployeeListByManager() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      userId: this.selectedManager.map((ele: any) => ele.id),
      isEligible: true,
      fromYear: this.fromYear,
      toYear: this.toYear,
      bands: this.getBandList.map((band: any) => band.name),
      department: this.getDepartmentsList.map((dept: any) => dept.name),

    }
    this.httpService.callPostService(this.config.getEmployeesListByManager, request).subscribe((result: any) => {
      if (result.data) {
        this.getEmployeeList = result.data.map((ele: any) => ({
          name: ele.name,
          id: ele.id
        })).sort((a: any, b: any) => a.name.localeCompare(b.name));;;
      }
    });
  }

  onSelectdEmployee() {
    if (this.selectedEmployee.length > 0) {
      this.getRatingListByEmployee();
      this.isGetIncrementLetter();

    } else {
      this.selectedEmployee = '';
    }
  }

  onDeSelectdEmployee() {
    this.getEmployeeList = [];
    this.selectedEmployee = '';
    this.isGetIncrementLetter();

  }

  selectAllEmployee(items: any) {
    this.selectedEmployee = items;
    this.selectedRating = '';
    this.onSelectdEmployee()
  }

  onDeSelectAllEmployee() {
    this.selectedEmployee = [];
    this.getRatingData = [];
    this.selectedRating = '';
    this.isGetIncrementLetter();

  }

  // Rating

  getRatingListByEmployee() {
    const employeeId = this.getEmployeeList.map((ele: any) => ele.id)
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear,
      "userId": employeeId
    }
    this.httpService.callPostService(this.config.getRatingsByUserId, request).subscribe((result: any) => {
      this.getRatingData = result.data.map((ele: any) => ({
        name: ele,
        id: ele,
      })).sort((a: any, b: any) => a.name.localeCompare(b.name));;;
    })
  }

  onSelectdRating() {
    if (this.selectedRating.length > 0) {
      this.isGetIncrementLetter();
    } else {
      this.selectedRating = "";
      this.getRatingData = [];
    }
  }

  onDeSelectdRating() {
    this.getRatingData = [];
    this.selectedRating = '';
  }

  selectAllRating(items: any) {
    this.selectedRating = items;
    this.onSelectdRating();
  }

  onDeSelectAllRating() {
    this.selectedRating = [];
    this.isGetIncrementLetter();

  }
  lettercouent: any

  isGetIncrementLetter() {
    this.incrementLetterData = [];
    const request = {
      "band": this.selectedBand?.length > 0 ? this.selectedBand.map((ele: any) => ele.name) : [],
      "companyId": this.loggedInUserCompanyID,
      "department": this.selectedDepartment?.length > 0 ? this.selectedDepartment.map((ele: any) => ele.name) : [],
      "designation": [],
      "employeeId": this.getEmployeeList?.length > 0 ? this.getEmployeeList.map((ele: any) => ele.id) : [],
      "fromYear": this.fromYear,
      "isEligible": true,
      "isHod": this.loggedInUserRole == 'HOD' && !this.isShowMD,
      "manager": this.selectedManager?.length > 0 ? this.selectedManager.map((ele: any) => ele.id) : [],
      "marketCorrection": null,
      "promotion": null,
      "ratings": this.selectedRating?.length > 0 ? this.selectedRating.map((ele: any) => ele.name) : [],
      "search": this.searchGenerateIncrementTableData,
      "toYear": this.toYear,
    }
    this.httpService.callPostService(this.config.getIncrementReport, request).subscribe((result: any) => {
      result.data.map((ele: any) => {
        ele.bandGrades.map((data: any) => {
          data.employeeData.map((result: any) => {
            this.incrementLetterData.push(result);
            this.lettercouent = this.incrementLetterData.length
          })
        });
      })
    })
  }

  private debounceTimer: any;

  onGenerateIncrementSearch(data: any) {
    var search = ''
    this.searchGenerateIncrementTableData = data;
    if (data == '') {
      this.searchGenerateIncrementTableData = null;
      this.isGetIncrementLetter();
      return;
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    if (data.length > 1) {
      this.debounceTimer = setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.isGetIncrementLetter();
            console.warn(data);

          },
            1000);
        }
      },
        1500);
    }
  }

  toggleSelectAll() {
    this.incrementLetterData.forEach(item => item.isChecked = this.selectAllChecked);
    this.isShowDownloadBtn = this.selectAllChecked;
  }

  onCheckboxChange() {
    const allChecked = this.incrementLetterData.every(item => item.isChecked);
    const anyChecked = this.incrementLetterData.some(item => item.isChecked);
    this.selectAllChecked = allChecked;
    this.isShowDownloadBtn = anyChecked;
  }

  downloadSelected() {
    const selectedIds = this?.incrementLetterData
      .filter((data: any) => data.isChecked) 
      .map((data: any) => data.inputId); 
    const request = {
      "id": selectedIds
    }
    this.httpService.callPostService(this.config.getLetterOfUsers, request).subscribe((result: any) => {
      const downloadFile: any = result.data;
      if (downloadFile) {
        const fileName = downloadFile.split('/').pop();
        // saveAs(downloadFile, fileName);
          this.downloadSign(result?.data)
      }
    })
  }

  onClickPreviewLetter(userName: any, userId: any) {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.height = '100%';
    // dialogConfig.width = '100%'; 
    dialogConfig.maxWidth = this.mobileresponsiveService.modelMaxWidth1200AndBelow;
    dialogConfig.data = {
      userName: userName,
      userId: userId,
      incrementLetterData: this.incrementLetterData,
      moduleName: 'Increment'
    };
     dialogConfig.panelClass = ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh', 'mat-mdc-dialog-content'];
    const dialogRef = this.dialog.open(GenerateIncrementlettersPreviewPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {});    
  }
  
  downloadSign(event: any) {
    if (event) {
      // Open the document in a new tab
      let fileUrl = `${this.config.downloadFile}${this.loggedInUserCompanyID}/${event}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }
}
